module.exports = __webpack_public_path__ + "img/testimonial-12-61x61_1testimonial-12-61x61.c67e24af.png";